import React, { useEffect, useState, useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import { MenuComponent } from 'Components/Menu'
import _ from 'lodash'
import { TagsGroup } from 'Components/Tag'
import { useIntl } from 'react-intl';
import Error from '@mui/icons-material/Error';
import Success from '@mui/icons-material/CheckCircle';
//global styles
import styles from "Assets/sass/core/vars.scss";
import '../../../landmarkSettingsView/style.scss'
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'Components';
import './style.scss';
import {
    openModalEditImportLandmark,
    clearRedux
} from "Redux/actions";

const LandMarkImportList = (props) => {
    const { data, callBack } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    return (
        <Grid
            item
            xs
            style={{
                width: '100%',
                margin: 0
            }}
        >
            <div style={{ padding: 10 }}>
                <div className={"lSettingsView-card lSettingsView-container"} style={{ padding: 10 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item xs={2}>
                            {
                                data.error &&
                                <Tooltip title={`${data.error}`} placement={'top'}>
                                    <div>
                                        <Error style={{ color: styles.red, fontSize: 20 }} title={data.error} />
                                    </div>
                                </Tooltip>
                            }

                            {
                                !data.error &&
                                <Success style={{ color: styles.green }} />
                            }

                        </Grid>

                        <Grid item xs={9} style={{ fontWeight: 'bold' }}>
                            {data.Name}
                        </Grid>


                        <Grid item xs={1} style={{ position: 'relative' }}>
                            <MenuComponent
                                options={[messages['edit'], messages['delete']]}
                                icon={'more_vert'}
                                className="lSetting-actions icon-menu-vehicle-service showInHover"
                                onClick={(type) => {
                                    if (type === messages['edit']) {
                                        dispatch(openModalEditImportLandmark(true, data))
                                    } else {
                                        callBack(data)
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        wrap="nowrap"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        onClick={() => {

                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <Grid item xs={12}>
                            <Typography noWrap variant="subtitle2" color={'textSecondary'} className="importLandmarkResponse">
                                {data?.Address}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        wrap="nowrap"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        onClick={() => {

                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <Grid item xs={6}>
                            <Typography noWrap variant="subtitle2" color={'textSecondary'}>
                                {`${messages['realtimemaps_landmarks_grid_groups']}: `}
                                <span className="importLandmarkResponse">
                                    {data?.Tags}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography noWrap variant="subtitle2" color={'textSecondary'}>
                                {`${messages['realtimemaps_landmarks_grid_radius']}: `}
                                <span className="importLandmarkResponse">
                                    {data?.Radius}
                                </span>
                            </Typography>
                        </Grid>
                    </Grid>


                </div>
            </div>

        </Grid>

    )
}

export default LandMarkImportList;